// function to chunk array into smaller arrays for paginations
export function chunkArray (array: any[] | undefined, size: number) {
  return array?.reduce((acc, _, i) => {
    if (i % size === 0) {
      acc.push(array.slice(i, i + size));
    }
    return acc;
  }, []);
}